import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CustomMailSettingI18n } from "@/components/features-new/custom-mail-setting";

import { useConfirmParams } from "./hooks";

export const CustomMailSettingI18nPage = () => {
	const result = useConfirmParams();

	const { hotelID, langCode, navigator } = result;

	return (
		<PageMeta
			title="基本メール設定"
			url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.I18N, { hotelID, langCode })}
		>
			<CustomMailSettingI18n hotelID={hotelID} langCode={langCode} navigator={navigator} />
		</PageMeta>
	);
};

CustomMailSettingI18nPage.displayName = "CustomMailSettingI18nPage";
